/**
 * Abstract content provider interface.
 * Generators receive content (tile mappings, tilesets, profiles) from a provider.
 */
export class ContentProvider {
  /** Get tile ID mappings for a generator type. */
  getTiles(generatorType) {
    throw new Error('Subclass must implement getTiles()');
  }

  /** Get tileset definitions for TMJ export. */
  getTilesets() {
    throw new Error('Subclass must implement getTilesets()');
  }

  /** Get room decoration templates. */
  getRoomTemplates(generatorType) {
    return [];
  }

  /** Get generation profile overrides. */
  getProfile(generatorType) {
    return {};
  }

  /** Package all content for a generator run. */
  getContent(generatorType) {
    return {
      tiles: this.getTiles(generatorType),
      tilesets: this.getTilesets(),
      roomTemplates: this.getRoomTemplates(generatorType),
      profile: this.getProfile(generatorType),
    };
  }
}
